export const translations = {
  // Menu items
  myActivities: 'My Activities',
  taskControl: 'New Demands',
  minhasNotas: 'New Demands',
  timeUsage: 'My Time Usage',
  chat: 'Chat',
  projects: 'Projects',
  nankinInsights: 'Nankin Insights',
  productSpec: 'Product Specification',
  gettingStarted: 'Getting Started',
  helpAndSupport: 'Help & Support',
  
  // Activities submenu
  strategic: 'Strategic View',
  monitoring: 'Monitoring',
  activities: 'Activities',
  'activities-2': 'Atividades 2',
  calendar: 'Calendar',
  
  // Tasks submenu
  inbox: 'Inbox',
  today: 'Today',
  upcoming: 'Upcoming',
  completed: 'Completed',
  
  // Time submenu
  tracker: 'Tracker',
  projectPlan: 'Project Plan',
  plannedVsActual: 'Planned vs Actual',
  reports: 'Reports',
  tags: 'Tags',

  // Finance submenu
  reconciliation: 'Reconciliation',
  'financial-movements': 'Financial Movements',
  'financial-dashboard': 'Financial Dashboard',
  'financial-projects': 'Projects',
  'financial-registers': 'Registers',
  'financial-calendar': 'Calendar',
  'financial-reports': 'Reports',

  // Common actions
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  save: 'Save',
  close: 'Close',
  
  // Settings
  settings: 'Settings',
  language: 'Language',
  selectLanguage: 'Select interface language',
  languageChanged: 'The selected language will be applied throughout the system interface'
} as const;